<template>
  <div class="container">
    <span class="buttons">
      <router-link
        :to="{ name: 'bovine.import' }"
        style="text-decoration: none"
      >
        <Button
          class="button-upload p-button-rounded p-shadow-5"
          icon="pi pi-upload"
        />
      </router-link>
    </span>
    <span class="buttons">
      <router-link
        :to="{ name: 'bovine.create' }"
        style="text-decoration: none"
      >
        <Button
          class="p-button-rounded p-shadow-5"
          icon="pi pi-plus"
          :style="{ width: '56px', height: '56px' }"
        />
      </router-link>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BovinePrintButton',
  props: {
    loading: Boolean,
  },
};
</script>

<style scoped>
.container {
  width: 56px;
  position: fixed;
  bottom: 1em;
  right: 1em;
  z-index: 1000;
}

@media (min-width: 600px) {
  .container {
    right: 2em;
  }
}

.container .buttons:not(:last-of-type) {
  width: 40px;
  height: 40px;
  margin: 15px auto 0;
  opacity: 1;
}

.button-upload,
.button-upload:hover {
  background-color: #16a000 !important;
  border-color: #16a000 !important;
}

.button-upload {
  width: 38px !important;
  height: 38px !important;
  padding: 5px;
}

.buttons {
  display: block;
  width: 35px;
  height: 35px;
  margin: 20px auto 0;
  position: relative;
  opacity: 0;
  transition: 0.2s;
}

.buttons:nth-last-of-type(2) {
  transition-delay: 20ms;
}

.buttons:nth-last-of-type(3) {
  transition-delay: 40ms;
}

.buttons:nth-last-of-type(1) {
  width: 56px;
  height: 56px;
  opacity: 1;
}
</style>
